import mapPropsCreate from 'app/common/containers/mapPropsCreate';
import createSelectPeriods from './selectPeriods';


export default mapPropsCreate(() => {
  const selectPeriods = createSelectPeriods();
  return props => ({
    ...props,
    periods: selectPeriods(props),
  });
});
